import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    this.destroyBeforeCache = this.destroy.bind(this)
    document.addEventListener("turbo:before-cache", this.destroyBeforeCache)
    this.initialize()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.destroyBeforeCache)
    this.destroy()
  }

  initialize() {
    if (!this.dataTablesAvailable()) return

    const $table = window.jQuery(this.element)
    if (window.jQuery.fn.DataTable.isDataTable(this.element)) return

    $table.DataTable(this.optionsValue || {})
  }

  destroy() {
    if (!this.dataTablesAvailable()) return
    if (!window.jQuery.fn.DataTable.isDataTable(this.element)) return

    window.jQuery(this.element).DataTable().destroy()
  }

  dataTablesAvailable() {
    return Boolean(window.jQuery?.fn?.DataTable)
  }
}
